import React from "react";
import Input from "../../../../Components/Common/Input";
import RadioInput from "../../../../Components/Common/RadioInput";
import ImageSelector from "../../../../Components/Common/ImageSelector";
import { CategoryApiUrls } from "../../../../Api/Auth/ApiUrls";
import useSWR from "swr";
import Selector from "../../../../Components/Common/Selector";

const TestForm = ({
  onChange,
  handleSubmit,
  errors,
  formData,
  setModalOpen,
}) => {
  const { isLoading, data } = useSWR(CategoryApiUrls.list);
  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <Input
          label="Title"
          type="text"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="Enter test title"
          error={errors.title}
          required
        />
        <RadioInput
          label="Test type:"
          name="free"
          options={[
            { label: "Free", value: "free" },
            { label: "Paid", value: "paid" },
          ]}
          checked={formData.free}
          onChange={onChange}
        />
        <Selector
          name="category"
          label="Category"
          value={formData?.category}
          options={data?.data?.map((item) => ({
            label: item.title,
            value: item._id,
          }))}
          isClearable={false}
          onChange={onChange}
          error={errors?.category}
          isLoading={isLoading}
          required
        />
        {formData.free === "paid" && (
          <Input
            label="Price"
            type="number"
            name="price"
            value={formData.price}
            onChange={onChange}
            placeholder="Enter test price"
            error={errors.price}
            required
          />
        )}
        <ImageSelector
          label="Upload File"
          name="link"
          setModalOpen={setModalOpen}
          onChange={onChange}
          value={formData.link}
          placeholder="Click to select a file"
        />
        {/* <Input
          label="Link"
          type="text"
          name="link"
          value={formData.link}
          onChange={onChange}
          placeholder="Enter test link"
          error={errors.link}
        /> */}
        <Input
          label="Action Button"
          type="text"
          name="actionButton"
          value={formData.actionButton}
          onChange={onChange}
          placeholder="Enter action button text"
          error={errors.actionButton}
        />
      </form>
    </>
  );
};

export default TestForm;
